import { getDateFilterDates } from '~/shared/utils/getDateFilterDates';

import { CUSTOM_DATES_TITLE, dateFilterItems } from '../common/dateFilterMenuItems';

export function getTableDateRange(activeDateFilter: string | null) {
  const isCustomDateViaParams = activeDateFilter?.includes(CUSTOM_DATES_TITLE);
  const durationForDateCalculation: { start: Duration; end?: Duration } | undefined =
    isCustomDateViaParams
      ? undefined
      : (() => {
          const currentFilterTitle = activeDateFilter || 'Last 3 hours';
          const dateFilterItem = dateFilterItems.find((f) => f.title === currentFilterTitle);
          return dateFilterItem?.duration;
        })();

  return getDateFilterDates(durationForDateCalculation, activeDateFilter, undefined, {
    futureHeadPaddingMs: 5 * 60 * 1000,
  });
}

export function parseSortField(raw: string | null): { field: string; dir: 'desc' | 'asc' } {
  if (!raw) {
    return { field: 'actionFinishTime', dir: 'desc' };
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && parsed.field && parsed.dir) {
      return parsed;
    }
  } catch (error) {
    console.error('Failed to parse sort field:', error);
  }
  return { field: 'actionFinishTime', dir: 'desc' };
}

export function buildSavingsQueryUrl(
  parsedFilters: string[],
  options?: { accountsScope?: string }
): string {
  const params = new URLSearchParams(parsedFilters.map((f) => ['filters', f]));
  if (options?.accountsScope) {
    params.set('accounts', options.accountsScope);
  }
  return `/api/v1/volumes/savings-stats?${params.toString()}`;
}

export function buildVolumeQueryUrl(
  filter: string,
  options?: { accountsScope?: string }
): string {
  const params = new URLSearchParams({ filters: filter });
  if (options?.accountsScope) {
    params.set('accounts', options.accountsScope);
  }
  return params.toString();
}
